import * as Yup from 'yup';

import { FieldRuleType } from 'constants/enums';
import { getCustomerRules, getDriverLicenseRules } from 'validation/genericRules';

export const getCustomerInformationSchema = (fieldsRules?: Record<string, FieldRuleType>) => Yup.object({
  customer: getCustomerRules(fieldsRules),
  driverLicense: getDriverLicenseRules({ fieldsRules }),
});
